import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InsertVideoIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "InsertVideo",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.51 4h-19C4.02 4 2.01 6.01 2 8.5v15c0 2.48 2.01 4.49 4.49 4.5h19c2.48 0 4.49-1.99 4.51-4.47V8.5c0-2.48-2.01-4.49-4.49-4.5m-6.4 16.73c.03.9-.68 1.65-1.58 1.68h-11c-.88-.05-1.56-.8-1.53-1.68v-10.1c-.03-.88.65-1.63 1.53-1.69h11c.9.03 1.61.79 1.58 1.69zm7.94-.34c0 .42-.3.65-.68.42l-5.45-3.65v-2.88l5.45-3.65c.38-.27.68-.09.68.37z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M17.26 23.14H9c-1.89 0-3.43-1.54-3.43-3.43v-6.86c0-1.89 1.54-3.43 3.43-3.43h8.26c1.89 0 3.43 1.54 3.43 3.43v6.86c0 1.89-1.54 3.43-3.43 3.43M9 11.71c-.63 0-1.14.51-1.14 1.14v6.86c0 .63.51 1.14 1.14 1.14h8.26c.63 0 1.14-.51 1.14-1.14v-6.86c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25 23.21q-.3 0-.57-.15l-5.45-3.15c-.55-.32-.73-1.01-.42-1.56.32-.55 1.01-.73 1.56-.42l3.74 2.16v-7.61l-3.74 2.16c-.55.31-1.25.13-1.56-.42-.32-.55-.13-1.25.42-1.56l5.45-3.15c.35-.2.79-.2 1.14 0s.57.58.57.99v11.57c0 .41-.22.79-.57.99q-.27.15-.57.15"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43M3.29 7.14c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      })]
    })
  }));
};